import { useState } from 'react';
import { useSelector } from 'react-redux';
import { deleteSmtpCredential } from '../../helpers/api_helper';

const useDeleteSmtpCredential = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const deleteSmtpCredentialHook = async (id) => {
        setLoading(true);
        setError(null);
        try {
            const response = await deleteSmtpCredential(tenantId, id);
            return response;
        } catch (err) {
            const errorMessage = `Failed to delete SMTP credential: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { deleteSmtpCredential: deleteSmtpCredentialHook, loading, error };
};

export default useDeleteSmtpCredential;